<template>
  <v-row
    no-gutters
    dense
  >
    <v-col
      cols="12"
    >
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-card
          outlined
        >
          <v-card-text>
            <v-row
              dense
              no-gutters
            >
              <v-col
                cols="12"
              >
                <v-row
                  dense
                >
                  <v-col cols="12">
                    <h4>Set Default Nameservers</h4>
                  </v-col>
                </v-row>
                <v-row
                  dense
                >
                  <v-col
                    cols="4"
                  >
                    <v-text-field
                      label="NS1"
                      v-model="form.default_ns1"
                      :rules="[rules.nameserver]"></v-text-field>
                  </v-col>
                  <v-col
                    cols="4"
                  >
                    <v-text-field
                      label="NS2"
                      v-model="form.default_ns2"
                      :rules="[rules.nameserver]"></v-text-field>
                  </v-col>
                </v-row>
                <v-row
                  dense
                >
                  <v-col
                    cols="4"
                  >
                    <v-text-field
                      label="NS3"
                      v-model="form.default_ns3"
                      :rules="[rules.nameserver]"></v-text-field>
                  </v-col>
                  <v-col
                    cols="4"
                  >
                    <v-text-field
                      label="NS4"
                      v-model="form.default_ns4"
                      :rules="[rules.nameserver]"></v-text-field>
                  </v-col>
                  <v-col
                    cols="4"
                  >
                    <v-text-field
                      label="NS5"
                      v-model="form.default_ns5"
                      :rules="[rules.nameserver]"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters dense>
              <v-row
                dense
              >
                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn
                    color="primary"
                    :loading="processing"
                    @click="submitForm"
                  >Submit</v-btn>
                </v-col>
              </v-row>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'DefaultNs',
  created() {
    this.$api.get('partner/settings').then((response) => {
      this.setSettings(response.data);
    });
  },
  data() {
    return {
      allowDisablePasswordLogin: false,
      processing: false,
      form: {
        default_ns1: '',
        default_ns2: '',
        default_ns3: '',
        default_ns4: '',
        default_ns5: '',
      },
      rules: {
        required: (value) => !!value || 'This field is required.',
        isNumeric: (value) => this.$underscore.isFinite(value) || 'This field must be numeric.',
        nameserver: (value) => (/(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/i).test(value)
          || this.$underscore.isEmpty(value) || 'This field must be valid hostname.',
      },
      valid: false,
    };
  },
  methods: {
    setSettings(settings) {
      this.form.default_ns1 = settings.ns1;
      this.form.default_ns2 = settings.ns2;
      this.form.default_ns3 = settings.ns3;
      this.form.default_ns4 = settings.ns4;
      this.form.default_ns5 = settings.ns5;
    },
    submitForm() {
      this.processing = true;
      if (this.$refs.form.validate()) {
        this.$api.put('partner/settings',
          this.form)
          .then(() => {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: 'Domain default nameservers are updated successfully.',
            });
          }).finally(() => {
            this.processing = false;
          });
      } else {
        this.processing = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
